import TrackProAPI from './track-pro-api'

export const fetchExternalFleetApi = () => {
    const endpoint = '/user/createToken'
    return TrackProAPI.post(endpoint)
}
